interface Props {
  color?: string
  width?: number
  height?: number
}

export const SendToFrontIcon = ({ color = '#6F6F6F', width = 21, height = 21 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.91992 0C8.74826 0.000100312 9.41992 0.671635 9.41992 1.5V3.68359H14.7607C15.5892 3.68361 16.2607 4.35517 16.2607 5.18359V11.5771H19.4971C20.3255 11.5771 20.997 12.2488 20.9971 13.0771V19.4971C20.9971 20.3255 20.3255 20.9971 19.4971 20.9971H13.0771C12.2488 20.997 11.5771 20.3254 11.5771 19.4971V16.2607H5.18359C4.3552 16.2607 3.68364 15.5891 3.68359 14.7607V9.41992H1.5C0.671624 9.41992 8.3757e-05 8.74828 0 7.91992V1.5C0 0.671573 0.671573 0 1.5 0H7.91992ZM16.2607 14.7607C16.2607 15.5891 15.5891 16.2607 14.7607 16.2607H12.5771V19.4971C12.5771 19.7732 12.8011 19.997 13.0771 19.9971H19.4971C19.7732 19.9971 19.9971 19.7732 19.9971 19.4971V13.0771C19.997 12.801 19.7732 12.5771 19.4971 12.5771H16.2607V14.7607ZM1.5 1C1.22386 1 1 1.22386 1 1.5V7.91992C1.00008 8.19599 1.22391 8.41992 1.5 8.41992H3.68359V5.18359C3.68359 4.35517 4.35517 3.68359 5.18359 3.68359H8.41992V1.5C8.41992 1.22392 8.19598 1.0001 7.91992 1H1.5Z"
        fill={color}
      />
    </svg>
  )
}
